import ScrollableContainer from "../../components/bonusUi/scrollable";

const Scrollable = () => {
  return <ScrollableContainer />;
};

export default Scrollable;
